const actions = {
  toggle({ commit }, { val, id }) {
    commit('setActiveStatus', { val, id });
  }
};

export default actions;
